export const ProgressCircle = ({ value }: { value: number }) => {
  const radius = 10;
  const circumference = 2 * Math.PI * radius;
  const strokeDashoffset = circumference - (value / 100) * circumference;

  return (
    <svg width='24' height='24' viewBox='0 0 24 24' className='shrink-0' aria-hidden='true'>
      <circle cx='12' cy='12' r={radius} fill='none' strokeWidth='2' stroke='#0000001a' />
      {value > 0 && (
        <circle
          cx='12'
          cy='12'
          r={radius}
          fill='none'
          strokeWidth='2'
          strokeLinecap='round'
          strokeDasharray={circumference}
          strokeDashoffset={strokeDashoffset}
          transform='rotate(-90 12 12)'
          stroke='#004c3d'
        />
      )}
    </svg>
  );
};
